export default "__VITE_ASSET__D9hy_d2c__"